import axios from "axios";

export const readPrivateOffice = async (alamatKontrak,newValue,statusSambung) => {
    try{
        return axios.get(`${process.env.REACT_APP_BACKEND_URL}/listPOBased?alamatKontrak=${alamatKontrak}&selectedRooms=${newValue}&statusSambung=${statusSambung}`,{
        })
    } catch(error){
        throw new Error(error);
    }
}